export default class DtoHydrometryStationMeasure {
    constructor(obj) {
        this.date = obj.creationDate
        this.hour = obj.hour
        this.value = obj.value
        this.flow = obj.flow
        this.speed = obj.speed
        this.pcAnalysis = obj.pcAnalysis
        this.hbAnalysis = obj.hbAnalysis
        this.continuity = obj.continuity
        this.obtainingMode = obj.obtainingMode
        this.precision = obj.precision
        this.validity = obj.validity
        this.qualification = obj.qualification
        this.nature = obj.nature
        this.type = obj.type
    }
}
